import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Globe, Linkedin, Facebook, Twitter } from "lucide-react";
import { siteInfo as fallbackSiteInfo, coreServices as fallbackCoreServices } from "../data";
import { getServices } from "../cms/serviceQueries";
import { getSiteContent } from "../cms/siteQueries";

export default function Footer() {
  const [siteInfo, setSiteInfo] = useState(fallbackSiteInfo);
  const [coreServices, setCoreServices] = useState(fallbackCoreServices);

  useEffect(() => {
    let mounted = true;
    Promise.all([getSiteContent(), getServices()])
      .then(([siteContent, cmsServices]) => {
        if (!mounted) return;
        if (siteContent?.company) setSiteInfo(siteContent.company);
        if (Array.isArray(cmsServices) && cmsServices.length > 0) setCoreServices(cmsServices);
      })
      .catch((error) => console.error("Unable to load Footer CMS content:", error));
    return () => { mounted = false; };
  }, []);

  return (
    <footer className="bg-[#0a1929] text-slate-300">
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <div className="bg-white p-2 rounded-sm">
              <img
                src={`${process.env.PUBLIC_URL || ""}/higa-logo.png`}
                alt="HIGA Automation"
                className="h-9 w-auto object-contain"
              />
            </div>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed mb-5">
            {siteInfo.legalName}. From concept to commissioning — we automate, fabricate and maintain factory infrastructure.
          </p>
          <div className="flex gap-3">
            {[Linkedin, Facebook, Twitter].map((Icon, i) => (
              <a
                key={i}
                href="#"
                className="w-9 h-9 rounded-sm border border-slate-700 flex items-center justify-center hover:border-[#c8102e] hover:text-white transition-colors"
              >
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-white font-bold text-sm uppercase tracking-widest mb-5 pb-3 border-b border-slate-700">Services</h4>
          <ul className="space-y-2.5 text-sm">
            {coreServices.map((s) => (
              <li key={s.slug}>
                <Link to={`/services#${s.slug}`} className="hover:text-white transition-colors">
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold text-sm uppercase tracking-widest mb-5 pb-3 border-b border-slate-700">Company</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/about" className="hover:text-white transition-colors">About Us</Link></li>
            <li><Link to="/industries" className="hover:text-white transition-colors">Industries Served</Link></li>
            <li><Link to="/services" className="hover:text-white transition-colors">Solutions Portfolio</Link></li>
            <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
            <li><Link to="/contact" className="hover:text-white transition-colors">Request A Quote</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold text-sm uppercase tracking-widest mb-5 pb-3 border-b border-slate-700">Get In Touch</h4>
          <ul className="space-y-3.5 text-sm">
            <li className="flex gap-3"><MapPin className="w-4 h-4 mt-0.5 text-[#c8102e] flex-shrink-0" /><span>{siteInfo.address}</span></li>
            <li className="flex gap-3"><Phone className="w-4 h-4 mt-0.5 text-[#c8102e] flex-shrink-0" /><a href={`tel:${siteInfo.phone}`} className="hover:text-white">{siteInfo.phone}</a></li>
            <li className="flex gap-3"><Mail className="w-4 h-4 mt-0.5 text-[#c8102e] flex-shrink-0" /><a href={`mailto:${siteInfo.email}`} className="hover:text-white">{siteInfo.email}</a></li>
            <li className="flex gap-3"><Globe className="w-4 h-4 mt-0.5 text-[#c8102e] flex-shrink-0" /><span>{siteInfo.website}</span></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} HIG Automation India Pvt. Ltd. All rights reserved.</div>
          <div className="tracking-widest">HEAT · INTEGRATE · GOVERN · AUTOMATE</div>
        </div>
      </div>
    </footer>
  );
}
